import { createSlice } from "@reduxjs/toolkit";

let initialState = {
    additionalServicesEnabled: false,
    ecommerceUrlEnabled:false,
    businessName:'',
    packageFeeEnabled:false,
    businessEmail:'',
    businessAddress:'',
    businessPhone:'',
    evoucherEnabled:false,
    featuredTeamsEnabled:false,
}

const configsSlice = createSlice({
    name: 'configs',
    initialState,
    reducers: {
        setAdditionalServices:(state,action) => {
            state.additionalServicesEnabled = action.payload;
        },
        setEcommerceUrl:(state,action) => {
            state.ecommerceUrlEnabled = action.payload;
        },
        setBusinessName:(state,action) => {
            state.businessName = action.payload;
        },
        setBusinessEmail:(state,action) => {
            state.businessEmail = action.payload;
        },
        setBusinessAddress:(state,action) => {
            state.businessAddress = action.payload;
        },
        setBusinessPhone:(state,action) => {
            state.businessPhone = action.payload;
        },
        setPackageFeeEnabled:(state,action) => {
            state.packageFeeEnabled = action.payload;
        },
        setEvoucherEnabled:(state,action) => {
            state.evoucherEnabled = action.payload;
        },
        setFeaturedTeamsEnabled:(state,action) => {
            state.featuredTeamsEnabled = action.payload;
        }
    }
});


export const {setAdditionalServices,setEcommerceUrl,setBusinessName, setBusinessAddress,setBusinessEmail,setBusinessPhone,setEvoucherEnabled, setPackageFeeEnabled, setFeaturedTeamsEnabled} = configsSlice.actions;
export default configsSlice.reducer;


